import React, { useState } from 'react'
import { FieldArray } from 'formik'

import { t } from 'translations'
import { Input, Button as MerinioButton, Card } from 'ui'

const SpecificRestrictionsForm = ({ disabled, restrictions = [] }) => {
  const [value, setValue] = useState('')

  return (
    <FieldArray
      name="specificRestrictions"
      render={arrayHelpers => (
        <div className="mb-3">
          <h5>{t('manager.users.form.SPECIFIC_RESTRICTIONS.TITLE')}</h5>
          <small className="form-text text-muted">{t('manager.users.form.SPECIFIC_RESTRICTIONS.SUMMARY')}</small>
          <Card className="bg-light">
            <div className="p-3">
              {restrictions.length ? (
                <ul>
                  {restrictions.map((restriction, index) => (
                    <li key={index}>
                      {restriction}{' '}
                      {!disabled && (
                        <span className="cursor-pointer" onClick={() => arrayHelpers.remove(index)}>
                          <i className="fas fa-trash" />
                        </span>
                      )}
                    </li>
                  ))}
                </ul>
              ) : (
                <small>{t('manager.users.form.SPECIFIC_RESTRICTIONS.NO_SPECIFIC_RESTRICTION')}</small>
              )}

              {!disabled && (
                <div className="form-group">
                  <label>{t('manager.users.form.SPECIFIC_RESTRICTIONS.ADD_RESTRICTION')}</label>
                  <div className="input-group">
                    <Input
                      type="text"
                      value={value}
                      placeholder={t('manager.users.form.SPECIFIC_RESTRICTIONS.PLACEHOLDER')}
                      onChange={e => setValue(e.target.value)}
                    />
                    <div className="input-group-append">
                      <MerinioButton
                        color="secondary"
                        type="button"
                        onClick={() => {
                          arrayHelpers.push(value)
                          setValue('')
                        }}
                        outlined
                      >
                        {t('manager.users.form.SPECIFIC_RESTRICTIONS.ADD')}
                      </MerinioButton>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </Card>
        </div>
      )}
    />
  )
}

export default SpecificRestrictionsForm
